import { ArrowUpRight, FileText } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/i18n";

const ITEMS = [
    {
        nr: "01",
        de: {
            title: "Projektierung & Fertigung",
            desc: "Kabelkopfstationen fertigen wir selbst — genau nach Ihren spezifischen Angaben, bestückt und programmiert in Hemhofen.",
        },
        en: {
            title: "Engineering & Manufacturing",
            desc: "We manufacture our own cable headends — built precisely to your specifications, assembled and programmed in Hemhofen.",
        },
    },
    {
        nr: "02",
        de: {
            title: "Planung & Berechnung",
            desc: "Auslegung und Pegelberechnung von SAT-ZF-Verteilanlagen sowie GA-, GGA- und BK-Verteilnetzen für jedes Objekt.",
        },
        en: {
            title: "Planning & Calculation",
            desc: "Design and level calculation of SAT-IF distribution systems as well as communal, large-estate and cable networks for any building.",
        },
    },
    {
        nr: "03",
        de: {
            title: "Technische Hilfestellung",
            desc: "Direkte Unterstützung bei Problemlösungen im Bereich Antennentechnik — vom Techniker, nicht vom Callcenter.",
        },
        en: {
            title: "Technical Support",
            desc: "Direct assistance with antenna technology problems — from a technician, not a call centre.",
        },
    },
    {
        nr: "04",
        de: {
            title: "Fachhandel & Logistik",
            desc: "Produkte namhafter Anbieter, übersichtlicher Fachhandelskatalog — alle Katalogartikel sind Lagerware, Lieferung DE & EU.",
        },
        en: {
            title: "Trade & Logistics",
            desc: "Products from leading brands in a clear trade catalogue — all catalogue items held in stock, delivery in DE & the EU.",
        },
        extra: { href: "/datenblaetter/katalog_ohne_preise.pdf", de: "Fachhandelskatalog (PDF)", en: "Trade catalogue (PDF)" },
    },
];

export default function Leistungen() {
    const { t } = useLang();
    return (
        <section id="leistungen" data-testid="leistungen" className="scroll-mt-24 py-16 sm:py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
                <Reveal>
                    <Eyebrow>{t("Leistungen", "Services")}</Eyebrow>
                    <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 max-w-2xl">
                        {t("Vier Gründe, warum Installateure auf Müller bauen.", "Four reasons why installers rely on Müller.")}
                    </h2>
                </Reveal>
                <div className="mt-10 border-t border-slate-200">
                    {ITEMS.map((it, i) => (
                        <Reveal key={it.nr} delay={i * 0.06}>
                            <div
                                data-testid={`leistung-row-${it.nr}`}
                                className="group grid sm:grid-cols-12 gap-3 sm:gap-6 items-baseline border-b border-slate-200 py-7 sm:py-8 px-2 sm:px-4 -mx-2 sm:mx-0 rounded-lg hover:bg-white hover:shadow-sm transition-all duration-300"
                            >
                                <span className="sm:col-span-1 font-mono text-sm text-red-700">{it.nr}</span>
                                <h3 className="sm:col-span-4 font-display text-lg sm:text-xl font-semibold text-slate-900">
                                    {t(it.de.title, it.en.title)}
                                </h3>
                                <p className="sm:col-span-5 text-sm sm:text-base leading-relaxed text-slate-600">{t(it.de.desc, it.en.desc)}</p>
                                <span className="sm:col-span-2 flex sm:justify-end items-start">
                                    {it.extra ? (
                                        <a
                                            href={it.extra.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-testid="leistung-katalog-link"
                                            className="inline-flex flex-wrap items-center gap-1.5 text-sm font-semibold text-red-700 hover:text-red-800 border-b border-red-300 pb-0.5 sm:justify-end sm:text-right"
                                        >
                                            <FileText className="h-4 w-4" />
                                            {t(it.extra.de, it.extra.en)}
                                        </a>
                                    ) : (
                                        <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-red-600 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                                    )}
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
